import React, { PureComponent, Fragment } from 'react'
import { Route } from 'react-router-dom'
import TvDisplay from './TvDisplay'
import Kiosk from './Kiosk'

// local components

export default class PluginsPage extends PureComponent {
  render() {
    const { match } = this.props

    return (
      <Fragment>
        <Route exact path={`${match.url}/`} component={TvDisplay} />
        <Route exact path={`${match.url}/check_in`} component={Kiosk} />
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Plugins/PluginsPage.js